import { useRef } from 'react';

import { useTheme, useMount } from '@simplywallst/ui-core';

import { VisxText } from '@/components/VisxText';

type Props = {
  x: number;
  fill: string;
  textAnchor: 'start' | 'middle' | 'end';
  children: string;
  onWidthUpdate: (width: number) => void;
};

export const TitleText = ({
  x,
  fill,
  textAnchor,
  children,
  onWidthUpdate,
}: Props) => {
  const theme = useTheme();
  const ref = useRef<SVGSVGElement>(null);
  const isEdgeNode = textAnchor === 'start' || textAnchor === 'end';
  const width = isEdgeNode ? 100 : undefined;
  const y = isEdgeNode ? -theme.x4spacePx : -theme.x5spacePx + 1;

  useMount(() => {
    if (ref.current) {
      const { width } = ref.current.getBBox();
      onWidthUpdate(width);
    }
  });

  return (
    <VisxText
      innerRef={ref}
      x={x}
      y={y}
      verticalAnchor="end"
      textAnchor={textAnchor}
      fill={fill}
      width={width}
      typography="xSmallStrong"
    >
      {children}
    </VisxText>
  );
};
